import React from 'react';
import './style.scss';

const ButtonVplus = ({ type = 'button', children, onClick, className, disabled, borderColor, ...rest }) => {
  const customStyle = {
    border: borderColor ? `1px solid ${borderColor}` : undefined,
    color: borderColor || undefined,
  };

  return (
    <button
      disabled={disabled}
      type={type}
      onClick={onClick}
      className={`btn-vplus ${className}`}
      style={customStyle}
      {...rest}
    >
      {children}
    </button>
  )
};

export default React.memo(ButtonVplus)